import { Box, Typography } from "@mui/material";

interface NewSheetTabProps {
    isMobile?: boolean;
}

const NewSheetTab: React.FC<NewSheetTabProps> = ({ isMobile = false }) => {
    return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" gutterBottom color="primary">
                New Inspection Sheet Ready
            </Typography>
            <Typography variant="body2" color="text.secondary">
                A fresh inspection form has been created below. Fill out the form and save when complete.
            </Typography>
        </Box>
    );
};

export default NewSheetTab;
